import React from 'react';
const InfoCircleAlertIcon = () => (React.createElement("svg", { width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("circle", { cx: "20", cy: "20", r: "12", fill: "#99C1FB", "fill-opacity": "0.2", stroke: "#0066F4", "stroke-width": "1.2" }),
    React.createElement("path", { d: "M20 18V27", stroke: "#0066F4", "stroke-width": "2.8", "stroke-linecap": "round" }),
    React.createElement("circle", { cx: "20", cy: "13", r: "2", fill: "#0066F4" })));
export default InfoCircleAlertIcon;
